import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Extract JWT token from URL hash BEFORE React mounts
// This runs synchronously before any React code
(function extractTokenFromHash() {
  const hash = window.location.hash;
  if (hash && hash.includes('token=')) {
    const token = hash.split('token=')[1];
    if (token) {
      localStorage.setItem('authToken', token);
      // Clear the hash from URL
      window.history.replaceState(null, '', window.location.pathname);
      console.log('[Auth] Token extracted from URL and saved');
    }
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
